import { Plus, Trash2, GripVertical } from "lucide-react";
import { ICON_NAMES } from "../data/site";

export function Field({ label, value, onChange, placeholder, type = "text" }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</span>
      <input
        type={type}
        value={value ?? ""}
        placeholder={placeholder}
        onChange={(e) => onChange(type === "number" ? Number(e.target.value) : e.target.value)}
        className="mt-1.5 w-full rounded-lg border border-border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
      />
    </label>
  );
}

export function TextArea({ label, value, onChange, rows = 3 }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</span>
      <textarea
        rows={rows}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1.5 w-full rounded-lg border border-border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
      />
    </label>
  );
}

export function IconField({ label = "Icon", value, onChange }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</span>
      <select
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1.5 w-full rounded-lg border border-border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
      >
        <option value="" disabled>Select an icon</option>
        {ICON_NAMES.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
    </label>
  );
}

export function ImageField({ label = "Image URL", value, onChange }) {
  return (
    <div>
      <Field label={label} value={value} onChange={onChange} placeholder="https://..." />
      {value ? (
        <img src={value} alt="preview" className="mt-2 h-24 w-full rounded-lg border border-border object-cover" />
      ) : null}
    </div>
  );
}

export function ItemCard({ index, onRemove, children, title }) {
  return (
    <div className="relative rounded-xl border border-border bg-card p-4">
      <div className="mb-3 flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-muted-foreground">
          <GripVertical className="h-3.5 w-3.5" /> {title || `Item ${index + 1}`}
        </span>
        <button type="button" onClick={onRemove} className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-destructive hover:bg-destructive/10" data-testid={`remove-item-${index}`}>
          <Trash2 className="h-3.5 w-3.5" /> Remove
        </button>
      </div>
      <div className="grid gap-3">{children}</div>
    </div>
  );
}

export function AddButton({ onClick, label = "Add item" }) {
  return (
    <button type="button" onClick={onClick} className="inline-flex items-center gap-1.5 rounded-full border border-dashed border-primary/50 px-4 py-2 text-sm font-medium text-primary hover:bg-primary/5" data-testid="add-item-btn">
      <Plus className="h-4 w-4" /> {label}
    </button>
  );
}

// Generic helpers to immutably update arrays
export const updateAt = (arr, i, patch) => arr.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
export const removeAt = (arr, i) => arr.filter((_, idx) => idx !== i);
